import de from './de.js'
import en from './en.js'
import fr from './fr.js'
import ja from './ja.js'

const messages = {
  de, en, fr, ja
}
export default messages


// WEBPACK FOOTER //
// ./src/language/language.js